import axios from 'axios';
import space from '../constants/space';

const sureAxios = axios.create({
  baseURL: process.env.REACT_APP_SURE_API_BASE_URL,
  headers: {
    'X-Space': space,
  },
});

export default sureAxios;
